import CloseIcon from '@mui/icons-material/Close';
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useDrawMapStore } from "../..";
import useIsHalfScreenMap from "../../hooks/useIsHalfScreenMap";
import { DrawMapMode } from "../../store/DrawMapStore";
import commonStyles from '../Common.module.css';
import Dropdown from "../Dropdown";
import DrawIcon from "../icons/DrawIcon";
import styles from './Header.module.css';

function DrawDropdown() {
    const isHalfScreenMap = useIsHalfScreenMap();
    const drawMapStore = useDrawMapStore();
    const [areDrawToolsOpen, setAreDrawToolsOpen] = useState(false);

    return (
        <>
            <Dropdown
                className={styles.dropdown}
                title="Draw"
                isOpen={areDrawToolsOpen}
                setIsOpen={setAreDrawToolsOpen}
                hasNotification={drawMapStore.mode === DrawMapMode.FocusArea}
                icon={<DrawIcon color={drawMapStore.mode === DrawMapMode.FocusArea ? "#FEFEFE" : "#25479A"} />}
            >
                <ul>
                    <li>
                        <Link to="/savedViews" className={commonStyles.noLink} onClick={() => setAreDrawToolsOpen(false)}>
                            <label>Save/Update View</label>
                        </Link>
                    </li>
                    <li>
                        <label
                            className={!drawMapStore.isDrawControlAvailable() ? styles.inactive : ""}
                            onClick={() => {
                                if (drawMapStore.mode !== DrawMapMode.FocusArea && drawMapStore.isDrawControlAvailable()) {
                                    setAreDrawToolsOpen(false);
                                    drawMapStore.drawFocusArea();
                                } else if (drawMapStore.mode === DrawMapMode.FocusArea) {
                                    setAreDrawToolsOpen(false);
                                    drawMapStore.clear();
                                }
                            }}
                        >{drawMapStore.mode === DrawMapMode.FocusArea ? "Remove Focus" : "Focus Area"}</label>
                    </li>
                    <li>
                        <Link to="/insights" className={commonStyles.noLink} onClick={() => setAreDrawToolsOpen(false)}>
                            <label>View Insights</label>
                        </Link>
                    </li>
                    <li>
                        <Link to="/tenantsInMarket/create" className={commonStyles.noLink} onClick={() => setAreDrawToolsOpen(false)}>
                            <label>Add Tenant in Market</label>
                        </Link>
                    </li>
                </ul>
            </Dropdown>
            {drawMapStore.mode === DrawMapMode.FocusArea && !!drawMapStore.result && (
                <div className={isHalfScreenMap ? commonStyles.halfWidthOnMapPanel : commonStyles.onMapPanel}>
                    Remove Focus Area
                    <CloseIcon className={commonStyles.clickableIcon} onClick={() => drawMapStore.clear()} />
                </div>
            )}
        </>
    );
}

export default observer(DrawDropdown);